// Drafts stay in router history, not persistent storage. A fresh server quote
// is required after login; no payment state or bearer token is restored.
export const portalSessionIdentity = (session) => {
  const client = Number(session?.id);
  const salon = Number(session?.salon_id);
  return client > 0 && salon > 0 ? { client, salon } : null;
};

export const bookingRecoveryState = (loginState, session) => {
  const candidate = loginState?.fromState;
  const identity = portalSessionIdentity(session);
  const owner = candidate?.draftOwner;
  if (!identity || !owner || identity.client !== owner.client || identity.salon !== owner.salon
    || !Array.isArray(candidate?.draft?.lines) || !candidate.draft.lines.length) return null;
  return { draft: candidate.draft, draftOwner: owner };
};
